import { graphql } from "@opensea/graphql"
import { CollectionItemsBuyActionsFragment } from "./CollectionItemsBuyActions.fragment"

export const CollectionItemsActionsFragment = graphql(
  `
    fragment CollectionItemsActions on Collection {
      ...CollectionItemsBuyActions
    }
  `,
  [CollectionItemsBuyActionsFragment],
)
